import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { AgentForm } from '../components/agents/AgentForm';
import { useCreateAgent, useAssignPrompt } from '../hooks/useAgents';

export default function NewAgentPage() {
  const navigate = useNavigate();
  const createAgent = useCreateAgent();
  const assignPrompt = useAssignPrompt();

  const handleSubmit = async (data: any) => {
    const { selectedPromptId, ...agentData } = data;
    const newAgent = await createAgent.mutateAsync(agentData);

    // If a prompt was selected, assign it to the new agent
    if (selectedPromptId && newAgent?.id) {
      try {
        await assignPrompt.mutateAsync({ agentId: newAgent.id, promptId: selectedPromptId });
      } catch (error) {
        console.error('Failed to assign prompt to new agent:', error);
        // Still navigate even if prompt assignment fails
      }
    }

    navigate('/agents');
  };

  return (
    <div>
      <PageHeader
        title="Create Agent"
        description="Create a new AI agent"
      />
      <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <AgentForm mode="create" onSubmit={handleSubmit} />
      </div>
    </div>
  );
}
